module.exports = __webpack_public_path__ + "static/media/help_business_job_add.cbf71fcb.jpg";